module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/status-changed-3bc9ac0b7e0c3f40c20a021032265d80.svg";